<template>
    <div>
        <div class="wizardWrapper">
            <div class="checkout-wrap">
                <div class="pageLayout">
                    <div class="contentSection">
                        <div class="textdetails">
                            <h5> Review Details</h5>
                            <p>Your Appointment details are:</p>
                        </div>

                        <div class="infoTable">
                            <table>
                                <thead>
                                    <tr>
                                        <th colspan="2">
                                            <div class="lableText"><i>Appointment Venue</i></div>
                                            <div class="detailsText">
                                                Land Transport Authority Customer Service Centre<br />
                                                10 Sin Ming Drive, Singapore 575701
                                            </div>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th>
                                            <div class="lableText"><i>Appointment Date </i></div>
                                            <div class="detailsText">
                                                {{ formatApptDate(appointmentDetails.appointmentDate) }}
                                            </div>
                                        </th>
                                        <th>
                                            <div class="lableText"><i>Appointment Time</i></div>
                                            <div class="detailsText">
                                                {{ formatTime(appointmentDetails.startTime) }}
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colspan="2">
                                            <div class="lableText">Name</div>
                                            <div class="detailsText">
                                                {{ appointmentDetails.name }}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="lableText">Mobile Number</div>
                                            <div class="detailsText">
                                                <span v-if="appointmentDetails.phoneNumber">
                                                    {{ appointmentDetails.phoneNumber }}
                                                </span>
                                                <span v-else>-</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="lableText">Email Address</div>
                                            <div class="detailsText">
                                                <span v-if="appointmentDetails.email">
                                                    {{ appointmentDetails.email }}
                                                </span>
                                                <span v-else>-</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div class="lableText">Service Name</div>
                                            <div class="detailsText">
                                                {{ appointmentDetails.serviceName }}
                                            </div>
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="p-0">
                                            <div class="appInfoDetails" v-if="isVehicalShow">
                                                <div class="lableText">Vehicle Number</div>
                                                <div class="detailsText">{{ capitalize(appointmentDetails.vehicleNumber)  }}</div>
                                            </div>

                                            <div class="appInfoDetails" v-if="isNoticeShow">
                                                <div class="lableText">Notice Number</div>
                                                <div class="detailsText">{{capitalize(appointmentDetails.noticeNumber)}}</div>
                                            </div>

                                            <div class="appInfoDetails" v-if="isVacShow">
                                                <div class="lableText">VAC Number</div>
                                                <div class="detailsText">{{ capitalize(appointmentDetails.vacNumber)}}
                                                </div>
                                            </div>

                                            <div class="appInfoDetails" v-if="isPARFShow">
                                                <div class="lableText">PARF Number</div>
                                                <div class="detailsText">{{ capitalize(appointmentDetails.parfNumber) 
                                                }}</div>
                                            </div>

                                            <div class="appInfoDetails" v-if="isCEORShow">
                                                <div class="lableText">COE Number</div>
                                                <div class="detailsText">{{ appointmentDetails.coeNumber | capitalize }}
                                                </div>
                                            </div>

                                            <div class="appInfoDetails" v-if="isTcoeShow">
                                                <div class="lableText">TCOE Number</div>
                                                <div class="detailsText">{{ capitalize(appointmentDetails.tcoeNumber) }}</div>
                                            </div>

                                            <div class="appInfoDetails" v-if="ishVParkShow">
                                                <div class="lableText">HV Park Number</div>
                                                <div class="detailsText">{{ capitalize(appointmentDetails.hvParkNumber) }}</div>
                                            </div>

                                            <div class="appInfoDetails" v-if="isDeviceNumberShow">
                                                <div class="lableText">Device Number</div>
                                                <div class="detailsText">{{ capitalize(appointmentDetails.deviceNumber)  }}</div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <div class="lableText">Notes to LTA</div>
                                            <div class="detailsText">{{ appointmentDetails.remarks }}</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <p class="mt-4">
                            To change any details, please select Back.<br />
                            To proceed with your selection, please select Confirm within 3 minutes.
                        </p>

                        <div class="footerBtn">
                            <div class="p-col-12">
                                <div class="float-Left">
                                    <Button label="< Back" @click="onBackAction" class="linkBtn customLinkCss" />
                                </div>
                                <div class="float-Right">
                                    <Button label="Confirm" v-focus @click="onNextAction" class="btn p-button-raised" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onBeforeMount, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useApiService } from '@/utils/useApiService';
import { useNotifications } from '@/utils/useNotifications';
const { notifyError, notifyInfoError } = useNotifications()
const emit = defineEmits(['backClick', 'nextClick'])
const { fetchWrapperForGet, fetchWrapperForPost } = useApiService()
const store = useStore();
const router = useRouter();

const id = ref(null);
const appointmentDetailsAppointmentDate = ref('');
const appointmentDetails = ref({
    name: '',
    startTime: '',
    email: '',
    phoneNumber: '',
    vehicleNumber: '',
    noticeNumber: '',
    vacNumber: '',
    parfNumber: '',
    coeNumber: '',
    tcoeNumber: '',
    hvParkNumber: '',
    serviceName: '',
    deviceNumber: '',
    remarks: ''
});

const isVehicalShow = ref(false);
const isNoticeShow = ref(false);
const isVacShow = ref(false);
const isPARFShow = ref(false);
const isCEORShow = ref(false);
const isTcoeShow = ref(false);
const ishVParkShow = ref(false);
const isDeviceNumberShow = ref(false);

onBeforeMount(() => {
    getData();
});

function getData() {
    id.value = store.getters.getAppointmentId;
    appointmentDetailsAppointmentDate.value = store.getters.getAppointmentDateString;
    appointmentDetails.value = store.getters.getMopAppointmentDetails;
}
function formatApptDate(value) {
    if (!value) return ''

    let dateObj

    if (typeof value === 'string') {
        const dtTimeArray = value.split('T')
        dateObj = new Date(dtTimeArray[0])
    } else if (value instanceof Date) {
        dateObj = value
    } else {
        return ''
    }

    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ]
    const days = [
        "Sunday", "Monday", "Tuesday", "Wednesday",
        "Thursday", "Friday", "Saturday"
    ]

    return `${dateObj.getDate()} ${monthNames[dateObj.getMonth()]} ${dateObj.getFullYear()}, ${days[dateObj.getDay()]}`
}
function formatTime(time) {
    if (!time) return ''

    const [hours, minutes] = time.split(':')
    const h = parseInt(hours, 10)
    const m = parseInt(minutes, 10)

    const period = h >= 12 ? 'PM' : 'AM'
    const formattedHour = h % 12 === 0 ? 12 : h % 12
    const formattedMinute = m.toString().padStart(2, '0')

    return `${formattedHour}:${formattedMinute} ${period}`
}
function onNextAction() {
    const todaysDate = new Date();
    if (
        new Date(appointmentDetails.value.appointmentDate).getTime() > todaysDate.getTime() &&
        appointmentDetails.value.startTime &&
        appointmentDetails.value.endTime
    ) {
        fetchWrapperForGet('api/HeartBeat', false, false, false).then(() => {
            const payload = { id: id.value };
            fetchWrapperForPost('api/mop/appointments', payload, false, true, true, true).then((data) => {
                if (data) {
                    store.dispatch('reset').then(() => {
                        const transDt = formatTransactDateTime12(data.generateDateTime);
                        store.dispatch('setTransactionDateString', transDt).then(() => {
                            store.dispatch('setAppointmentDateString', appointmentDetailsAppointmentDate.value).then(() => {
                                store.dispatch('setAppointmentAcknowlegement', data).then(() => {
                                    router.push({ path: '/AppointmentAcknowledgementDetails' });
                                });
                            });
                        });
                    });
                }
            });
        }).catch((err) => {
            if (err.errorCode === 422) {
                notifyInfoError("Your session has expired due to inactivity. Please  try again.", okFunction);
            } else {
                notifyError(err);
                emit('backClick');
            }
        });
    } else {
        notifyInfoError("Please select appointment date and time.", onBackAction);
    }
}

function okFunction() {
    fetchWrapperForGet('api/MopSessions/Delete', false, false, true).then(() => {
        store.dispatch('reset').then(() => {
            window.location.reload();
        });
    });
}
function capitalize(value) {
    if (!value) return "";
    value = value.toString();
    return value.toUpperCase();
}
function onBackAction() {
    emit('backClick');
}

watch(() => appointmentDetails.value.vehicleNumber, val => { if (val) isVehicalShow.value = true; });
watch(() => appointmentDetails.value.noticeNumber, val => { if (val) isNoticeShow.value = true; });
watch(() => appointmentDetails.value.vacNumber, val => { if (val) isVacShow.value = true; });
watch(() => appointmentDetails.value.parfNumber, val => { if (val) isPARFShow.value = true; });
watch(() => appointmentDetails.value.coeNumber, val => { if (val) isCEORShow.value = true; });
watch(() => appointmentDetails.value.tcoeNumber, val => { if (val) isTcoeShow.value = true; });
watch(() => appointmentDetails.value.hvParkNumber, val => { if (val) ishVParkShow.value = true; });
watch(() => appointmentDetails.value.deviceNumber, val => { if (val) isDeviceNumberShow.value = true; });

const vFocus = {
    mounted: (el) => el.focus()
};

function formatTransactDateTime12(value) {
    if (value) {
        const dtTimeArray = value.split('T');
        const datePart = dtTimeArray[0];
        const timePart = dtTimeArray[1].split('.')[0]; // Remove milliseconds

        const [year, month, day] = datePart.split('-').map(Number);
        const [hour, minute, second] = timePart.split(':').map(Number);

        const date = new Date(year, month - 1, day, hour, minute, second);

        const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];

        const days = [
            "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
        ];

        const dayName = days[date.getDay()];
        const dayNum = date.getDate();
        const monthName = monthNames[date.getMonth()];
        const yearNum = date.getFullYear();

        // Convert to 12-hour format with AM/PM
        let hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;

        const timeFormatted = `${hours}:${minutes} ${ampm}`;

        return `${dayNum} ${monthName} ${yearNum}, ${dayName}, ${timeFormatted}`;
    }
    return value;
}

</script>

<style scoped>
.wizarContactdWrapper {
    float: left;
    width: 100%;
    padding-bottom: 50px;
    background: white;
}

.requiredIcon {
    color: red;
    font-size: large;
    font-style: normal;
    margin: auto;
}

p.m-0 {
    margin: 7px 0;
}
.footerBtn {
    float: left;
    width: 100%;
    margin-bottom: 60px;
}
</style>
